import {StatusWayPointSingleVoyage} from "@containers/singleVoyage/types/point";

export const getPointBorderColorByStatusSingleVoyage = (status: StatusWayPointSingleVoyage) => {
    switch (status) {
        case "COMPLETED":
            return '#33F752'
        default:
            return '#b4b2b2'
    }
}

export const getPointBorderTypeColorByStatusSingleVoyage = (status: StatusWayPointSingleVoyage) => {
    switch (status) {
        // case "expected": return 'dashed'
        case "COMPLETED":
            return 'solid'
        default:
            return 'dashed'
    }
}


export const getPointColorByStatusSingleVoyage = (status: StatusWayPointSingleVoyage) => {
    switch (status) {
        case "PLANNED":
            return '#fff'
        case "COMPLETED":
            return '#33F752'
        case "SKIPPED":
            return 'red'
        case "IN_PROGRESS":
            return 'green'
        case "PARTIAL_COMPLETED":
            return '#33F752'
        case "DELETED":
            return 'black'
        default:
            return '#F1A378'
    }
}

export const getPointColorByStatusSecondarySingleVoyage = (status: StatusWayPointSingleVoyage): string => {
    if(!status){
        return  '#602e2f'
    }
    switch (status) {
        case "PLANNED":
            return '#FFCB46'
        case "COMPLETED":
            return 'white'
        case "IN_PROGRESS":
            return '#b4b2b2'
        case "DELETED":
            return 'black'
        case "SKIPPED":
            return 'black'
        default :
            return '#602e2f'
    }
}

export const getPointTextColorByStatusSecondarySingleVoyage = (status: StatusWayPointSingleVoyage): string => {
    if(!status){
        return  'white'
    }
    switch (status) {
        case "DELETED":
            return 'white'
        case "SKIPPED":
            return 'white'
        default :
            return '#222'
    }
}